import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import StepperComponent from "../StepperComponent/StepperComponent";
import OTPComponent from "../OTPComponent/OTPComponent";
import ImageUpload from "../ImageUpload/ImageUpload";
import DomainVerificationIcon from "@mui/icons-material/DomainVerification";
import DoneIcon from "@mui/icons-material/Done";
import Storelist from "../../Store/Actions";
import EngineeringTwoToneIcon from "@mui/icons-material/EngineeringTwoTone";
import "./style.scss";
import SparesQR from "../SparesQR/SparesQR";
import useApiPost from "../../Hooks/usePost";
import { BASE_URL_API } from "../../appconfig";
import { toast } from "react-toastify";
import Api from "../../Utils/Api";

const PickupModal = ({ openModal, closeModal }) => {
  const [step, setStep] = useState(0);
  const { PageStore, dropModal, ServiceDetailsStore, setLoading } = Storelist();
  const verifyOtpApi = useApiPost();
  const statusChange = useApiPost();
  const statusChange2 = useApiPost();
  const serviceDetail = ServiceDetailsStore?.data;
  const { GetRequestByID,GetRequestsList } = Api();

  const stepsConfig = [
    {
      label: "Verify OTP",
      icon: DomainVerificationIcon,
      component: OTPComponent,
    },
  ];

  const VerifyOTP = () => (
    <>
      <OTPComponent submitOTP={verifyOtp}></OTPComponent>
    </>
  );


  /**
   * Verify OTP of a service request.
   * @param {string} otp - OTP to be verified.
   */
  const verifyOtp = (otp) => {
    
    verifyOtpApi.Postdata(`${BASE_URL_API()}ServiceVerifyOtp`, true, {
      serviceId: serviceDetail?.bikeRequest?._id,
      sotp: otp,
    });
  };

  useEffect(() => {
    if (verifyOtpApi?.data !== null) {
      if (verifyOtpApi?.data?.status == 200) {
        statusChangeApi();
      }
    } else if (verifyOtpApi?.error !== null) {
      toast.error(
        verifyOtpApi?.error?.message
          ? verifyOtpApi?.error.message
          : "Something went wrong",
        {
          position: "top-center",
        }
      );
      verifyOtpApi.setError(null);
    }
  }, [verifyOtpApi?.data, verifyOtpApi?.error]);

  const statusChangeApi = () => {
    setLoading(true);
    statusChange.Postdata(`${BASE_URL_API()}pickupPersonStatusChange`, true, {
      serviceId: serviceDetail?.bikeRequest?._id,
    });
  };

  /**
   * Handles the response of the status change API call. and do the side effects
   */
  useEffect(() => {
    if (statusChange?.data !== null) {
      if (statusChange?.data?.status === 200) {
        statusChange.setData(null);
        // GetRequestByID(serviceDetail?.bikeRequest?._id);
        statusChangeApi2();
        // switchStep();
      }
    } else if (statusChange?.error !== null) {
      toast.error(
        statusChange?.error?.message
          ? statusChange?.error.message
          : "Something went wrong",
        {
          position: "top-center",
        }
      );
      statusChange.setError(null);
    }
    setLoading(false);
  }, [statusChange?.data, statusChange?.error]);


  const statusChangeApi2 = () => {
    setLoading(true);
    statusChange2.Postdata(`${BASE_URL_API()}pickupPersonStatusChange`, true, {
      serviceId: serviceDetail?.bikeRequest?._id,
    });
  };



  useEffect(() => {
    if (statusChange2?.data !== null) {
      if (statusChange2?.data?.status === 200) {
        statusChange2.setData(null);
        console.log("srtatus chanhge");
        GetRequestByID(serviceDetail?.bikeRequest?._id);
        GetRequestsList();
        setStep(0);
        dropModal();
        toast.success("Bicycle delivered successfully", { position: "top-center" });
      }
    } else if (statusChange2?.error !== null) {
      toast.error(
        statusChange2?.error?.message
          ? statusChange2?.error.message
          : "Something went wrong",
        {
          position: "top-center",
        }
      );
      statusChange2.setError(null);
    }
    setLoading(false);
  }, [statusChange2?.data, statusChange2?.error]);







  const renderComponent = (step) => {
    switch (step) {
      case 0:
        return <VerifyOTP />;
      
      default:
        return null;
    }
  };
  return (
    <Modal
      open={PageStore?.dropModal}
      closable={{ "aria-label": "Custom Close Button" }}
      maskClosable={false}
      onCancel={() => dropModal()}
      closeIcon={
        <CloseOutlined
          style={{
            color: "black",
            backgroundColor: "#ffffff",
          }}
        />
      }
      footer={null}
    >
      <div className="border  pt-3 flex flex-col justify-center items-center">
        <StepperComponent
          activeStep={step}
          steps={stepsConfig}
        ></StepperComponent>
        {renderComponent(step)}
      </div>
    </Modal>
  );
};

export default PickupModal;
